import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { prettyFloatMoney } from '@/helpers/utils';
import { EMPTY_DASH } from '@/helpers/constants';
import IconUp from './arrow-up.svg'
import IconCoins from './coins-stacked-01.svg'
import IconTrend from './trend-up-01.svg'
import IconBar from './horizontal-bar-chart-01.svg'
import IconLayer from './layers-two-01.svg'
import s from './index.module.scss';

export const Statistics = ({ data }) => {
  const { t } = useTranslation('loans');
  const cards = [
    {
      id: 'total_rounds',
      icon: IconLayer,
      label: t('statistics.total_rounds'),
      value: data ? data.total_count : EMPTY_DASH,
    },
    {
      id: 'claims_amount',
      icon: IconCoins,
      label: t('statistics.claims_amount'),
      value: data
        ? prettyFloatMoney(data.total_amount, {
            decimalPlaces: 2,
          })
        : EMPTY_DASH,
    },
    {
      id: 'repayment_average',
      icon: IconBar,
      label: t('statistics.repayment_average'),
      value: data ? `${data.repayment_average || 0}%` : EMPTY_DASH,
    },
    {
      id: 'total_repayments',
      icon: IconUp,
      label: t('statistics.total_repayments'),
      value: data
        ? prettyFloatMoney(data.total_repayments, {
            decimalPlaces: 2,
          })
        : EMPTY_DASH,
    },
    {
      id: 'total_earnings',
      icon: IconTrend,
      label: t('statistics.total_earnings'),
      value: data
        ? `+ ${prettyFloatMoney(data.total_earnings + data.total_accrued, {
            decimalPlaces: 2,
          })}`
        : EMPTY_DASH,
    },
  ];

  return (
    <div className={s.wrapper}>
      <div className={s.inner}>
        {cards.map(item => (
          <div className={s.card} key={item.id}>
            <div className={s.card_label}>
              <img
                src={item.icon}
                alt={item.label}
                width={20}
                height={20}
                style={{ minWidth: '20px' }}
              />
              <span className="f-small-accent">{item.label}</span>
            </div>
            <div className={classnames(s.card_value, item.id)}>
              <span className="f-article-accent">{item.value}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};